var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlixxCoin3D = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5064 13.8938C36.1981 16.2324 36.488 19.201 35.538 22.217C34.5858 25.2402 32.3949 28.2606 29.2249 30.5537C22.8179 35.1885 15.3358 34.7847 11.9636 30.1231C8.55924 25.417 10.3061 17.5804 16.6575 12.9858C23.0093 8.39098 31.1023 9.18807 34.5064 13.8938Z",
    stroke: "url(#paint0_linear_4730_24321)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4004 10.9202C38.6872 17.1853 37.3217 24.7608 29.9672 30.7294C22.3947 36.313 14.1804 34.966 9.86282 29.4743C5.54522 23.9826 7.12876 14.8538 13.834 10.0033C20.5392 5.1528 29.4227 5.42146 33.4004 10.9202Z",
    fill: "url(#paint1_linear_4730_24321)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5201 11.7578C34.1861 14.0608 34.4882 16.9869 33.5569 19.9785C32.6226 22.9792 30.4551 25.9862 27.3002 28.2685C20.9104 32.8908 13.5189 32.4102 10.2013 27.824C6.84325 23.182 8.50588 15.4004 14.8263 10.8283C21.1471 6.25581 29.1624 7.11621 32.5201 11.7578Z",
    stroke: "url(#paint2_linear_4730_24321)",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7579 10.269C33.8265 14.511 32.0846 21.7621 25.7335 26.3564C19.3823 30.9508 11.9503 30.336 8.88171 26.0941C5.81311 21.8521 7.55504 14.601 13.9061 10.0066C20.2572 5.41231 27.6893 6.02706 30.7579 10.269Z",
    fill: "#FFD93B",
    stroke: "url(#paint3_linear_4730_24321)",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4588 11.827C32.3012 15.7562 30.625 22.0562 25.3623 25.8632C20.0995 29.6703 13.5914 29.2907 10.749 25.3615C7.90668 21.4323 9.58288 15.1323 14.8456 11.3253C20.1083 7.51825 26.6165 7.89778 29.4588 11.827Z",
    stroke: "url(#paint4_linear_4730_24321)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4730_24321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7506 16.3177C23.5976 16.7976 23.8821 17.3997 23.8821 17.3997L24.6974 15.9646L24.6796 15.9451C24.2454 15.4776 23.6748 15.0458 23.2226 14.7896C21.4263 13.7695 20.4907 14.7944 20.0922 15.4956L19.6809 16.2191L18.5901 15.5995L17.9183 16.7829L19.0091 17.4024L18.5337 18.2401L17.4439 17.6226L16.7703 18.8115L17.8591 19.4284L17.0634 20.8305L18.7058 21.7635L19.5027 20.3595L21.2199 21.3324L22.2197 20.3284L20.1772 19.1712L20.6514 18.3359L22.3662 19.3098L23.3643 18.3113L21.3232 17.1525L21.61 16.6485C21.797 16.3185 22.0239 15.906 22.7506 16.3177Z",
    fill: "url(#paint5_linear_4730_24321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4730_24321",
    x: 16.7703,
    y: 14.3594,
    width: 7.92706,
    height: 7.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4730_24321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4730_24321",
    x1: 34.5897,
    y1: 12.2891,
    x2: 14.8238,
    y2: 34.8371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4730_24321",
    x1: 33.854,
    y1: 12.2955,
    x2: 12.2033,
    y2: 34.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#FDEE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#E8BB06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#D57B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#C86101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660555,
    stopColor: "#D88C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771761,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815114,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881945,
    stopColor: "#E8AE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930202,
    stopColor: "#D98317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBAE4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4730_24321",
    x1: 32.7955,
    y1: 9.99189,
    x2: 12.8407,
    y2: 32.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4730_24321",
    x1: 25.4782,
    y1: 5.13854,
    x2: 15.7086,
    y2: 31.2593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#FFED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4730_24321",
    x1: 14.6631,
    y1: 10.3534,
    x2: 26.5316,
    y2: 26.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4991A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#EAAA2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4730_24321",
    x1: 22.4525,
    y1: 14.3533,
    x2: 18.364,
    y2: 21.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#DC9731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD7C1B"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlixxCoin3D);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flixx-coin-3d.cd35a64f84f2993ede18e0fd2d6302c2.svg";